import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "modal-mask" }
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-xl modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "modal-title" }
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "list-group" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "fa-regular fa-square-check"
}
const _hoisted_11 = {
  key: 1,
  class: "fa-regular fa-square"
}

import { ref, computed, onMounted } from 'vue'
    import { boolCompare } from '@common/Common'

    import type { AlternativeReadModel } from '@Evaluation/Estimations/Domain/readmodels'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'PanelistAlternativesSelector',
  props: {
    CorrelationId: {},
    Title: {},
    Alternatives: {},
    SelectedAlternativesIds: {}
  },
  emits: ["confirm", "close"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- local state ----------------

    const alternatives = ref<AlternativeVM[] | null>(null)

    // ---------------- computed ----------------

    const alternativesView = computed<AlternativeVM[] | undefined>(() =>
    {
        return alternatives.value?.slice().sort((a, b) =>
            boolCompare(a.Included, b.Included)
        )
    })

    // ---------------- lifecycle ----------------

    onMounted(() =>
    {
        const selectedIds = props.SelectedAlternativesIds ?? []

        alternatives.value = props.Alternatives.map(
            a => new AlternativeVM(
                a,
                selectedIds.indexOf(a.AlternativeId) > -1
            )
        )
    })

    // ---------------- actions ----------------

    function confirm()
    {
        if (!alternatives.value)
            return

        emit('confirm', {
            CorrelationId: props.CorrelationId,
            SelectedIds: alternatives.value
                .filter(a => a.Included === true)
                .map(a => a.AlternativeId)
        })
    }

    function close()
    {
        emit('close')
    }

    // ---------------- runtime VM ----------------

    class AlternativeVM
    {
        AlternativeId: number
        Name: string
        Included: boolean

        constructor(a: AlternativeReadModel, included: boolean)
        {
            this.AlternativeId = a.AlternativeId
            this.Name = a.Name
            this.Included = included
        }

        toggleIncluded()
        {
            this.Included = !this.Included
        }
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h5", _hoisted_6, _toDisplayString(__props.Title), 1 /* TEXT */),
            _createElementVNode("button", {
              onClick: close,
              type: "button",
              class: "close"
            }, "×")
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(alternativesView.value, (a) => {
                return (_openBlock(), _createElementBlock("button", {
                  type: "button",
                  key: a.AlternativeId,
                  onClick: ($event: any) => (a.toggleIncluded()),
                  class: "list-group-item list-group-item-action"
                }, [
                  (a.Included)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10))
                    : _createCommentVNode("v-if", true),
                  (!a.Included)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11))
                    : _createCommentVNode("v-if", true),
                  _createTextVNode(" " + _toDisplayString(a.Name), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_9))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]),
          _createElementVNode("div", { class: "modal-footer" }, [
            _createElementVNode("button", {
              onClick: confirm,
              type: "button",
              class: "btn btn-primary"
            }, "Confirm"),
            _createElementVNode("button", {
              onClick: close,
              type: "button",
              class: "btn btn-outline-secondary"
            }, "Cancel")
          ])
        ])
      ])
    ])
  ]))
}
}

})